export const parseJSONDate = function (jsonDate) {
  if (jsonDate === null) {
    return null;
  }
  let date = new Date(parseInt(jsonDate.substr(6)));
  if (date.getFullYear() === 1970) { // we couldn't parse it, means that it is most likely a iso 8601 datetime
    date = Date.parse(jsonDate);
  }

  return date;
};
export const ProductIsAvailable = function (date) {
  const today = new Date();
  return date && new Date(date) <= today;
};

export const ProductIsAvailableInFuture = function (date) {
  const today = new Date();
  return date && new Date(date) > today;
};

export const DisplayDate = function (dateToDisplay, options = { year: 'numeric', month: 'long', day: 'numeric' }) {
  const date = new Date(dateToDisplay);
  const lang = document.getElementsByTagName('html')[0].getAttribute('lang');
  return date.toLocaleDateString(lang, options);
};

export const isoDateToYMD = function (d) {
  if (!d) {
    return null;
  }
  const date = new Date(d);
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = String(date.getFullYear()).padStart(4, '0');

  return `${yyyy}-${mm}-${dd}`;
};

export const FormatToGoogleDate = function (date) {
  return new Date(date).toISOString().replace(/-|:|\.\d+/g, '');
};

export const FormatToOutlookOrAppleDate = function (date) {
  return new Date(date).toISOString().replace(/-|:|\.\d+/g, '').replace('Z', '');
};

export const FormatTimeByBrowser = function (time) {
  const timeObject = new Date(time);
  const options = {
    hour: '2-digit'
  };
  return timeObject.toLocaleTimeString(undefined, options);
};
